import React from 'react';
import { Feature, InjectorService } from '@tencent/workbench';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import ColorPickerContainer from '@src/js/common/ark-extensions/dc-components/color-picker/color-picker-container';
import { ColorPickerType } from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import { IShadowShower } from '@tencent/drawing-drawer-components';
import { ShadowFeature } from '@framework/workbench/drawer/ui/effects/shadow/shadow-feature';

const DEFAULT_EMPTY_COLOR = '#000000';

@Feature()
export class ShadowShower extends BaseDrawerEffectFeature implements IShadowShower {
    private shadowFeature: ShadowFeature;
    public constructor() {
        super();
        this.shadowFeature = InjectorService.get(ShadowFeature);
    }

    public getShadowSize = () => this.getShownValue(INPUT_PROPS_CALLBACK_KEY.SHADOW, { size: this.shadowFeature.size });

    public shouldShadowSizeDisabled = () => !this.shadowFeature.shadowInfo.isOuter;

    public getShadowBlur = () => this.getShownValue(
        INPUT_PROPS_CALLBACK_KEY.SHADOW,
        { blurRad: this.shadowFeature.blur },
    );

    public getShadowDistance = () => this.getShownValue(
        INPUT_PROPS_CALLBACK_KEY.SHADOW,
        { dist: this.shadowFeature.dist },
    );

    public getShadowOpacity = () => this.getShownValue(
        INPUT_PROPS_CALLBACK_KEY.SHADOW,
        { opacity: this.shadowFeature.opacity },
    );

    public getShadowAngle = () => {
        let dir: any = this.shadowFeature.shadowProps?.dir;
        if (typeof dir !== 'number') {
            dir =  Number(dir?.match(/\d*/)[0]);
        }
        return this.getShownValue(INPUT_PROPS_CALLBACK_KEY.SHADOW, { dir });
    };

    public getShadowColor = () => this.shadowFeature.shadowInfo?.tdColor.rgba || DEFAULT_EMPTY_COLOR;

    public getDropContent = () => <ColorPickerContainer
        onColorHover={this.handleColorEnter}
        onMouseLeave={this.handlePaletteLeave}
        selectedTdColor={this.shadowFeature.shadowInfo?.tdColor || new TDColor({ rgbaStr: DEFAULT_EMPTY_COLOR })}
        onColorChange={this.shadowFeature.handleShadowColorChange}
        colorPickerType={ColorPickerType.StandardPC}
    />;

    // hover 到颜色上时预览属性
    private handleColorEnter = (color) => {
        if (this.checkSelectType() > 1) {
            return;
        }
        this.shadowFeature.updatePreviewInfo(color);
        this.shadowFeature.updateShadowProps(true, true);
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(true);
    };

    private handlePaletteLeave = () => {
        if (this.checkSelectType() > 1) {
            return;
        }
        this.shadowFeature.updatePreviewInfo();
        this.shadowFeature.updateShadowProps(true);
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
    };
}
